import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteQuestionFeedbackMutation, deleteQuestionFeedbackMutationVariables } from '../generated/deleteQuestionFeedbackMutation';
import { questionFeedbackFieldsFragment } from '../models/QuestionFeedback';

/**
 * Get a callback to delete a QuestionFeedback in the store.
 */
export function useDeleteQuestionFeedbackCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteQuestionFeedbackMutation, deleteQuestionFeedbackMutationVariables>(
        gql`
            mutation deleteQuestionFeedbackMutation ($id: ID!) {
                deleteQuestionFeedback(id: $id) {
                    ...questionFeedbackFields
                }
            }

            ${questionFeedbackFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
